import { render, staticRenderFns } from "./ProductRegistrationLayout.vue?vue&type=template&id=273ee6de"
import script from "./ProductRegistrationLayout.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports